"use client";

import {SectionDivider} from "app/components/shared/SectionDivider";
import {Box, Flex} from "@chakra-ui/react";
import {AdvanceNetworkCard} from "app/advance-network/components/networkcards";
import {MANAGED_COLOCATION_FEATURES_LIST} from "./constants";

const WhyManagedColocation = () => {
  return (
    <Box data-cy="section-why-managedColocation">
      <SectionDivider label="Why Managed Colocations?" />
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        gap={"2%"}
        data-cy="section-colocation-features"
      >
        {MANAGED_COLOCATION_FEATURES_LIST.map((data, index) => (
          <Box key={index} minWidth={"320px"} maxWidth={"23%"} marginBottom={6}>
            <AdvanceNetworkCard
              title={data.title}
              image={data.image}
              content={data.content}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default WhyManagedColocation;
